// Shared data and constants for the Jornada do Sono landing page.

export const PRODUCT = {
  name: "Jornada do Sono",
  subtitle: "Construindo a Autonomia do seu bebê",
  author: "Mariana Mello",
  price: 497,
  priceFormatted: "R$ 497",
  priceFull: "R$ 497,00",
  priceInstallment: "12x de R$ 51,40",
  priceCash: "ou R$ 497 à vista",
  priceOriginal: "R$ 994,00",
  checkoutUrl: "https://pay.kiwify.com.br/f1TRpAh",
  whatsappUrl:
    "https://wa.me/553497403520?text=Ol%C3%A1%20Mariana%2C%20vim%20pela%20p%C3%A1gina%20da%20Jornada%20do%20Sono%20e%20gostaria%20de%20tirar%20uma%20d%C3%BAvida.",
  instagramUrl: "https://instagram.com/marimello.sonodobebe",
};

export const IMAGES = {
  logo: "/images/logo-jornada.webp",
  logoGenerated:
    "https://static.prod-images.emergentagent.com/jobs/027f3e8e-1c92-4c6d-a8ab-b1c69d97cee8/images/c2273865c151bac4ef6882129f024d5a6af31f17a106c595a5944494ee6c1236.png",
  heroBokeh:
    "https://static.prod-images.emergentagent.com/jobs/027f3e8e-1c92-4c6d-a8ab-b1c69d97cee8/images/ea7a9eca188b211f36fba856cca252971dc774c1426be0b0940aac330f54b987.png",
  sleepingBaby:
    "https://static.prod-images.emergentagent.com/jobs/027f3e8e-1c92-4c6d-a8ab-b1c69d97cee8/images/23d3a08e343d4b4d897cc3a7e8a550aacb2ad86a2fca49196a20490f040f9c54.png",
  marianaPortrait: "/images/mariana-real.webp",
  guaranteeBadge:
    "https://static.prod-images.emergentagent.com/jobs/027f3e8e-1c92-4c6d-a8ab-b1c69d97cee8/images/35e8c42058ee2ec7b6cff3d471a13be5a6607de1314b968d89d733fad93bcfc4.png",
};

export const PHASES = [
  {
    n: "01",
    title: "Fundamentos e rotina",
    bullets: [
      "Entender como o sono do seu filho funciona de verdade",
      "Cronotipos, janelas de sono e necessidade de sono total por idade",
      "Impacto da alimentação e organização das sonecas",
      "A base que sustenta qualquer mudança no sono",
    ],
  },
  {
    n: "02",
    title: "Higiene e ambiente",
    bullets: [
      "Ritual pré-sono e controle da exposição à luz",
      "Produção de melatonina e ambiente que facilita o adormecer",
      "Montagem do quarto seguro por faixa etária",
    ],
  },
  {
    n: "03",
    title: "Triagem clínica",
    bullets: [
      "Identificar condições médicas que interferem no sono",
      "Quando a autonomia não deve ser iniciada ainda",
      "Sinais que exigem investigação profissional",
      "Nenhum método funciona sobre um problema de saúde não resolvido",
    ],
  },
  {
    n: "04",
    title: "Ensino da autonomia",
    bullets: [
      "Escolha do método adequado ao perfil do seu filho",
      "Abordagens diferentes, desde 2 meses até crianças de 5 anos",
      "Passo a passo detalhado de cada método",
    ],
  },
  {
    n: "05",
    title: "Estratégias por faixa etária",
    bullets: [
      "0 a 4 meses, 4 meses a 2 anos e 3 anos em diante",
      "Tabelas práticas de consulta para cada fase",
      "O que fazer exatamente em cada idade",
    ],
  },
  {
    n: "06",
    title: "Consolidação e manutenção",
    bullets: [
      "Atravessar regressões de sono sem perder o progresso",
      "O que fazer em doenças, viagens e mudanças de rotina",
      "Reverter recaídas temporárias com segurança",
      "Manter os resultados conquistados a longo prazo",
    ],
  },
];

export const FOR_WHOM_YES = [
  "Mães de bebês entre 2 meses e 2 anos que acordam várias vezes por noite",
  "Mães de crianças entre 2 e 5 anos com resistência ou dificuldade para dormir",
  "Mães que já tentaram dicas isoladas sem resultado consistente",
  "Mães prestes a voltar ao trabalho ou que já voltaram e estão exaustas",
  "Mães que querem uma abordagem respeitosa, baseada em evidências",
  "Mães dispostas a seguir um protocolo em sequência, com consistência",
];

export const FOR_WHOM_NO = [
  "Mães que esperam uma solução sem nenhuma mudança de rotina",
  "Mães que esperam resultado já na primeira noite",
  "Famílias com condições médicas não investigadas que interferem no sono",
  "Mães que já têm uma rotina de sono funcionando bem",
  "Quem busca atalhos sem entender a causa real dos despertares",
  "Mães que não estão dispostas a seguir o protocolo em sequência",
];

export const MODULES = [
  {
    n: "01",
    title: "Fundamentos do Sono e Estruturação da Rotina",
    description:
      "A base que sustenta toda a Jornada. Você entende como o sono do seu filho funciona antes de mudar qualquer coisa.",
    learnings: [
      "Seja bem-vinda, mãe",
      "Como funciona o sono infantil",
      "Estruturando a rotina",
      "Sonecas",
    ],
    icon: "BookOpen",
  },
  {
    n: "02",
    title: "Higiene do Sono e Ambiente",
    description:
      "Pequenos ajustes no ambiente já resolvem parte do problema. Aqui você prepara o terreno para o sono acontecer.",
    learnings: ["Ambiente de sono", "Higiene do sono"],
    icon: "Moon",
  },
  {
    n: "03",
    title: "Segurança Clínica Antes da Autonomia",
    description:
      "Antes de aplicar qualquer método, você descarta o que pode estar atrapalhando o sono do seu filho do ponto de vista clínico.",
    learnings: ["Segurança clínica antes da autonomia"],
    icon: "Stethoscope",
  },
  {
    n: "04",
    title: "Métodos de Ensino da Autonomia",
    description:
      "O coração da Jornada. Aqui você escolhe o método mais respeitoso para o perfil do seu filho e aplica em ordem.",
    learnings: [
      "Escolhendo o método ideal",
      "Método rápido x gradual",
      "Troca de associações",
      "Continuação",
      "Método intermediário",
      "Método rápido",
      "Cama montessoriana",
      "Crianças de 3 a 5 anos",
    ],
    icon: "Sparkles",
  },
  {
    n: "05",
    title: "Estratégias por Faixa Etária",
    description:
      "Você recebe um caminho específico para cada idade, com tabelas prontas para consulta.",
    learnings: [
      "Bebês de 2 a 6 meses",
      "Bebês de 6 meses até 2 anos",
      "Crianças de 2 a 5 anos",
    ],
    icon: "Baby",
  },
  {
    n: "06",
    title: "Consolidação e Manutenção",
    description:
      "O que diferencia famílias que mantêm o resultado das que recaem em duas semanas. Você se prepara para o que vier.",
    learnings: ["Pós autonomia", "O que pode alterar a autonomia", "Aula final"],
    icon: "ShieldCheck",
  },
];

// Único bônus exclusivo após PRD-06.
export const BONUSES = [
  {
    n: "01",
    title: "Lives Quinzenais — Plantão de Dúvidas por 12 Meses",
    description:
      "Durante 12 meses você terá acesso a encontros ao vivo com a Mariana Mello. A cada quinze dias, a Mari ficará ao vivo por aproximadamente uma hora respondendo dúvidas das alunas presentes. Você poderá levar dificuldades reais, receber direcionamento e ajustar a aplicação do método.",
    price: "R$ 497,00",
    icon: "Video",
    badge: "BÔNUS EXCLUSIVO",
  },
];

export const VALUE_STACK = [
  ["Curso completo — 6 módulos, 21 aulas em vídeo", "R$ 497,00"],
  ["Bônus — Lives Quinzenais com Mariana Mello (12 meses)", "R$ 497,00"],
];

export const TOP_TESTIMONIALS = [];

// 11 depoimentos integrais fornecidos pelo cliente.
export const BIG_TESTIMONIALS = [
  {
    name: "Kelly",
    role: "mãe do Guilherme",
    text: "Foi mais fácil chegar na autonomia do que acreditava. A Mari nos passa muita segurança no que fala, é só colocar em prática que funciona, respeitando claro a individualidade de cada família e cada bebê.",
    highlight: "É só colocar em prática que funciona.",
  },
  {
    name: "Sabrina",
    role: "mãe do Joaquim",
    text: "Rotina estipulada me ajudou muito a ter mais tranquilidade no dia a dia com meu bebê. Hoje ele dorme melhor e tem boa rotina graças à mentoria.",
    highlight: "Hoje ele dorme melhor e tem boa rotina.",
  },
  {
    name: "Jaqueline",
    role: "mãe da Joana",
    text: "Ajustar a rotina. Entender sobre pressão de sono, horas diárias e noturnas de sono. Autonomia de sono. Ter qualidade de tempo com a minha bebê quando ela está acordada e ter um pouco de tempo livre quando ela está dormindo para fazer minhas atividades. Muito obrigada!",
    highlight:
      "Qualidade de tempo com a minha bebê acordada e tempo livre quando ela dorme.",
  },
  {
    name: "Carla",
    role: "mãe do Dante",
    text: "A vida da nossa família mudou depois que o Dante conseguiu dormir no berço e depois ter conquistado a autonomia. Seguindo as dicas da Mari e ajustando tudo que precisava, conseguimos melhorar tudo e passamos a dormir. Uma pena não ter começado antes. Indico de olhos fechados.",
    highlight: "Uma pena não ter começado antes. Indico de olhos fechados.",
  },
  {
    name: "Bruna",
    role: "mãe da Lia",
    text: "Incrível. Hoje consigo dormir bem, minha filha dorme bem, graças à Mari. Temos uma qualidade de vida.",
    highlight: "Hoje consigo dormir bem, minha filha dorme bem.",
  },
  {
    name: "Estefânia",
    role: "mãe do Ezra",
    text: "Quando comecei, estava esgotada. Demorava mais de uma hora para fazer o meu bebê adormecer. Com os ajustes de rotina, comecei a ensinar autonomia, e em um mês e meio ele já estava dormindo sozinho, tanto no sono noturno quanto nas sonecas.",
    highlight: "Em um mês e meio ele já estava dormindo sozinho.",
  },
  {
    name: "Géssica",
    role: "mãe do Pedro",
    text: "Meu bebê não dormia bem, em consequência a casa inteira também não. A Mari me deu um suporte maravilhoso com muito carinho e paciência pra lidar com meu bebê até que finalmente conseguimos concluir a autonomia de sono dele. Hoje meu bebê dorme super bem e pode desfrutar de uma mãe feliz pra cuidar dele. Mari me ajudou a entender melhor sobre a rotina do bebê, sobre horários, sobre associações do sono e aprendi também sobre o ritual de sono do bebê. Foi uma experiência muito importante pra mim, um divisor de águas na minha maternidade e na minha casa. Só tenho que agradecê-la pelo trabalho incrível.",
    highlight: "Um divisor de águas na minha maternidade e na minha casa.",
  },
  {
    name: "Juliana",
    role: "mãe do Augusto",
    text: "Confesso que fiquei com medo e duvidei um pouco se esse negócio de autonomia realmente daria certo. Eu achava que era impossível fazer o meu filho dormir sem ser no peito. À noite, eu levava de 1h30 a 2h para fazê-lo dormir, e durante o dia, nas sonecas, era a mesma coisa: eu dava peito o tempo todo até ele dormir. Me surpreendi muito com ele logo no início do processo de autonomia, porque ele aceitou muito rápido. Foi difícil nos primeiros dias, mas segui firme na decisão. Hoje, ele dorme sozinho tanto no sono noturno quanto nas sonecas.",
    highlight:
      "Hoje ele dorme sozinho, tanto no sono noturno quanto nas sonecas.",
  },
  {
    name: "Maria Júlia",
    role: "mãe do Dom",
    text: "Minha experiência foi excelente, poder entender como melhorar a rotina do meu neném fez toda a diferença. Tudo o que sei sobre sono do bebê aprendi com a Mari e sou muito grata pois fez com que tivéssemos uma qualidade de sono melhor. Antes eu passava a noite com ele no peito para poder dormir, hoje ele acorda uma vez apenas para mamar.",
    highlight: "Hoje ele acorda uma vez apenas para mamar.",
  },
  {
    name: "Gabriela",
    role: "mãe do Akio",
    text: "Ter conhecido a Mari foi um acalanto na alma no meio do caos. Ela é doce, paciente, muito inteligente e sabe bem do que está falando. Ensina técnicas assertivas de como melhorar o sono do bebê e, consequentemente, de toda a família. Ela compartilha não só os ensinamentos teóricos, mas a própria experiência que ela teve com os filhos e nos faz ver que ela realmente aplica o que ensina — e que funciona. O que eu mais gostei foi poder viver o processo de autonomia do sono do meu bebê de forma leve. Indico de olhos fechados!",
    highlight:
      "Viver o processo de autonomia do sono do meu bebê de forma leve.",
  },
  {
    name: "Kesia",
    role: "mãe do Kael",
    text: "Está sendo excelente, estou tendo resultados muito bons. Na verdade, além do que eu esperava.",
    highlight: "Resultados muito bons. Além do que eu esperava.",
  },
];

export const FAQ_ITEMS = [
  {
    q: "A partir de qual idade posso começar a aplicar a Jornada?",
    a: "A Jornada do Sono cobre desde bebês de 2 meses até crianças acima de 5 anos. Cada faixa etária tem estratégias específicas. O Módulo 5 detalha exatamente o que fazer em cada fase do desenvolvimento, sem adaptação genérica.",
  },
  {
    q: "Meu filho tem menos de 4 meses. Ainda faz sentido entrar agora?",
    a: "Sim. O Módulo 1 cobre os fundamentos do sono para bebês desde os primeiros meses, incluindo janelas de sono, sonecas e necessidade total de sono. Organizar a base cedo evita que associações de sono problemáticas se instalem. Quanto antes você entende como o sono do seu filho funciona, menos você vai precisar desfazer depois.",
  },
  {
    q: "Os métodos ensinados causam sofrimento para o bebê?",
    a: "A Jornada oferece abordagens diferentes, com níveis distintos de presença dos pais durante o processo. Você escolhe o método mais adequado para o perfil do seu filho e para o que a sua família consegue sustentar. Nenhuma abordagem exige abandonar o filho ao choro sem resposta.",
  },
  {
    q: "Já tentei várias coisas e nada funcionou. Por que seria diferente agora?",
    a: "A maioria das tentativas falha por dois motivos: começar pelo método antes de organizar a base, ou aplicar uma técnica isolada sem entender a causa dos despertares. A Jornada resolve os dois problemas: você parte dos fundamentos, organiza o ambiente, faz a triagem clínica e só então escolhe o método. A sequência é o que muda o resultado.",
  },
  {
    q: "Quanto tempo leva para ver resultado?",
    a: "Depende da faixa etária da criança, do método escolhido e da consistência na aplicação. Os depoimentos de mães que seguiram a Jornada completa mostram resultados entre 2 e 7 semanas. Regressões pontuais podem acontecer e o Módulo 6 existe exatamente para isso.",
  },
  {
    q: "E se meu filho adoecer no meio do processo?",
    a: "O Módulo 6 cobre exatamente isso. Doenças, viagens e mudanças de rotina são intercorrências normais que afetam temporariamente o sono. A Jornada te orienta como atravessar o período e retomar sem perder o progresso conquistado.",
  },
  {
    q: "A Jornada funciona para crianças acima de 2 anos?",
    a: "Sim. O Módulo 5 possui estratégias específicas para crianças a partir dos 3 anos. A abordagem muda conforme o desenvolvimento cognitivo da criança.",
  },
];

export const CREDENTIALS = [
  "Fisioterapeuta pela Universidade Federal de Uberlândia (UFU)",
  "5 anos atuando em UTI Neonatal e Pediátrica",
  "Pós-Graduação em Terapia Intensiva Neonatal e Pediátrica",
  "Capacitação em Sono e Rotina do Bebê — Faculdade Brasília",
  "Capacitação Avançada em Insônia Pediátrica — Sleep Tight",
  "Capacitação Multiprofissional em Medicina do Sono — Instituto do Sono",
];
